import React from 'react'
import {Grid, Row, Col} from 'react-bootstrap'
import {Jumbotron} from 'react-bootstrap';
import ScrollLite from '../Navigation/ScrollLite.jsx';
import {Picture} from 'react-responsive-picture';
import suraj from '../Images/suraj.jpg'
import logo from '../Images/logo.jpg'

const clinicObject = {
  title: 'KAKKARA MULISPECIALITY DENTAL CLINIC',
  subtitle: 'Railway Station Road, Kalletumkara, Thrissur - 680683'
};

const doctorObject = {
  imagePath: "../Images/Suraj",
  imageType: "png",
  imageMaxRes: 3
};

const internals = {};

internals.styles = {
  clinic: {
    color: '#00cd96',
    borderRadius: '0',
    textAlign: 'center',
    background: 'transparent',
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  content: {
    maxWidth: '50vw'
  },
  scroll: {
    position: 'relative',
    top: '15vh'
  },
  aboutStyle: {
    textAlign: 'left',
    paddingTop: '30px',
    color: 'black',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    //fontSize: '2em'

  },
  background: {
    backgroundColor: 'rgba(255, 255, 255, 0.0)',
    paddingBottom: '100px'
  },
  avatar: {
    display: 'inline-block',
    maxWidth: '100%',
    backgroundColor: 'rgba(255,0,0,0,1)',
    borderRadius: '50%',
    overflow: 'hidden',
    margin: '100 0 0px'
  },
  logo: {
    display: 'inline-block',
    borderRadius: '50%',
    overflow: 'hidden',
    boxShadow: '3px 3px rgba(0, 0, 0, 0.3)'
  },
  h1:{
      textShadow: '2px 2px 4px rgba(0, 0, 0, 0.8)'
  }
};

export const Avatar = () => <div className="avatar" style={internals.styles.avatar}>
  <Picture src={suraj}/>
</div>;

export const Logo = () => <div className="avatar" style={internals.styles.logo}>
  <Picture src={logo}/>
</div>;

class About extends React.Component {
  render() {
    return (
      <div style={internals.styles.background}>
      <Jumbotron style={internals.styles.clinic} id='top'>
        <div>
          <Logo/>
          <br/><br/>
          <h1 style={internals.styles.h1}>{clinicObject.title}</h1>
          <h3 style={internals.styles.h3}>{clinicObject.subtitle}</h3>
        </div>

      </Jumbotron>


      <Grid id='about'>
        <h1>About</h1>
        <div><br/><br/></div>
        <Row>
          <Col sm={5} md={4}>
            <Avatar/>
          </Col>
          <Col sm={7} md={8}>
          <p style = {internals.styles.aboutStyle}> Babu Memorial Kakkara Dental Clinic located in Kalletumkara, Irinjalakuda is a multispeciality dental clinic under the leadership of Dr. Suraj Babu Kakkara. <br/> Dr. Suraj is an experienced dental surgeon who has previously worked with the renowned Prasy group based in Thrissur. Along with his expertise, the clinic has visiting doctors encompassing all major domains of Dentistry. </p>
          </Col>
        </Row>
      </Grid>
    </div>);
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/About/About.jsx